import React, { Component } from 'react'
import './Mag.css';

import img1 from '../assets/issue_19/001.jpg'
import img2 from '../assets/issue_19/002.jpg'
import img3 from '../assets/issue_19/003.jpg'
import img4 from '../assets/issue_19/004.jpg'
import img5 from '../assets/issue_19/005.jpg'
import img6 from '../assets/issue_19/006.jpg'
import img7 from '../assets/issue_19/007.jpg'
import img8 from '../assets/issue_19/008.jpg'
import img9 from '../assets/issue_19/009.jpg'
import img10 from '../assets/issue_19/010.jpg'
import img11 from '../assets/issue_19/011.jpg'
import img12 from '../assets/issue_19/012.jpg'
import img13 from '../assets/issue_19/013.jpg'
import img14 from '../assets/issue_19/014.jpg'
import img15 from '../assets/issue_19/015.jpg'
import img16 from '../assets/issue_19/016.jpg'
import img17 from '../assets/issue_19/017.jpg'
import img18 from '../assets/issue_19/018.jpg'
import img19 from '../assets/issue_19/019.jpg'
import img20 from '../assets/issue_19/020.jpg'
import img21 from '../assets/issue_19/021.jpg'
import img22 from '../assets/issue_19/022.jpg'
import img23 from '../assets/issue_19/023.jpg'
import img24 from '../assets/issue_19/024.jpg'
import img25 from '../assets/issue_19/025.jpg'
import img26 from '../assets/issue_19/026.jpg'
import img27 from '../assets/issue_19/027.jpg'
import img28 from '../assets/issue_19/028.jpg'
import img29 from '../assets/issue_19/029.jpg'
import img30 from '../assets/issue_19/030.jpg'
import img31 from '../assets/issue_19/031.jpg'
import img32 from '../assets/issue_19/032.jpg'
import img33 from '../assets/issue_19/033.jpg'
import img34 from '../assets/issue_19/034.jpg'
import img35 from '../assets/issue_19/035.jpg'
import img36 from '../assets/issue_19/036.jpg'
import img37 from '../assets/issue_19/037.jpg'
import img38 from '../assets/issue_19/038.jpg'
import img39 from '../assets/issue_19/039.jpg'
import img40 from '../assets/issue_19/040.jpg'
import img41 from '../assets/issue_19/041.jpg'
import img42 from '../assets/issue_19/042.jpg'
import img43 from '../assets/issue_19/043.jpg'
import img44 from '../assets/issue_19/044.jpg'


export default class Mag019 extends Component {
  render() {
    return (
      <div className="image-container">
        <img src={img1} className="image"></img>
        <img src={img2} className="image"></img>
        <img src={img3} className="image"></img>
        <img src={img4} className="image"></img>
        <img src={img5} className="image"></img>
        <img src={img6} className="image"></img>
        <img src={img7} className="image"></img>
        <img src={img8} className="image"></img>
        <img src={img9} className="image"></img>
        <img src={img10} className="image"></img>
        <img src={img11} className="image"></img>
        <img src={img12} className="image"></img>
        <img src={img13} className="image"></img>
        <img src={img14} className="image"></img>
        <img src={img15} className="image"></img>
        <img src={img16} className="image"></img>
        <img src={img17} className="image"></img>
        <img src={img18} className="image"></img>
        <img src={img19} className="image"></img>
        <img src={img20} className="image"></img>
        <img src={img21} className="image"></img>
        <img src={img22} className="image"></img>
        <img src={img23} className="image"></img>
         <img src={img24} className="image"></img>
        <img src={img25} className="image"></img>
        <img src={img26} className="image"></img>
        <img src={img27} className="image"></img>
        <img src={img28} className="image"></img>
        <img src={img29} className="image"></img>
        <img src={img30} className="image"></img>
        <img src={img31} className="image"></img>
        <img src={img32} className="image"></img>
        <img src={img33} className="image"></img>
        <img src={img34} className="image"></img>
        <img src={img35} className="image"></img>
        <img src={img36} className="image"></img>
        <img src={img37} className="image"></img>
        <img src={img38} className="image"></img>
        <img src={img39} className="image"></img>
        <img src={img40} className="image"></img>
        <img src={img41} className="image"></img>
        <img src={img42} className="image"></img>
        <img src={img43} className="image"></img>
        <img src={img44} className="image"></img>
      

      
      </div>
    )
  }
}
